import type { UserResponse } from "@sidegigllc/api/client";
import { isOnsiteManager } from "domains/auth/access/roles";

interface JobsRollout {
  /** The global LD `jobs-phased` value. */
  jobsPhased: number;
  /** The location's `jobs_enabled` override; absent counts as on until the backend ships the field. */
  jobsEnabled: boolean | undefined;
}

/** Jobs is turned on for the location: the global rollout switch plus the per-location override. */
export const isJobsRolledOut = ({ jobsPhased, jobsEnabled }: JobsRollout): boolean =>
  jobsPhased >= 1 && (jobsEnabled ?? true);

/**
 * Who sees Jobs: Jobs is rolled out for the location and the user is not an onsite manager.
 * Non-hook twin of `useHasJobsAccess`, for route guards.
 */
export const hasJobsAccess = (rollout: JobsRollout & { user: UserResponse | undefined; locationId: number }): boolean =>
  isJobsRolledOut(rollout) && !isOnsiteManager(rollout.user, rollout.locationId);
